import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Supprimer les erreurs de géolocalisation système (iOS/macOS) de la console
import './utils/suppressLocationErrors';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

